// Packages
import ListItem from 'modules/Customers/components/ContractListItem';
import PropTypes from 'prop-types';

// Other
import './styles.css';

const CustomerContractList = ({ isLoading, items, onChange, parent, parentId }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='CustomerContractList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>There are no contracts for this customer</h3>
		)
	}


	// Data State
	return (
		<div className='CustomerContractList'>

			{items.map((item, index) => {

				return (
					<div key={index}>
						<ListItem 
							{...item} 
							isLoading={false}
							onChange={() => {onChange()}}
							parent={parent}
							parentId={parentId}
						/>
					</div>
				)
				
			})}
	
		</div>
	)
}

CustomerContractList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
	parent: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

CustomerContractList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
	parent: '',
    parentId: ''
}

export default CustomerContractList;